import { Styles } from 'react-jss'

export const sheet: Styles = {
  main: {
    height: '100%',
    margin: '0 auto',
    minWidth: 360,
    position: 'relative',
    overflow: 'hidden'
  },
  root: {
    overflow: 'scroll',
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    height: '100%',
    width: '100%',
    maxHeight: 'calc(100vh - 52px)',
    boxSizing: 'border-box',
    '& h1': {
      color: '#080910'
    },
    '& h2': {
      margin: '0 0 8px 0'
    },
    '& h3': {
      margin: '18px 0 8px 0'
    },
    '& p': {
      margin: '0 0 8px 0',
      lineHeight: 1.5
    },
    '& ul, & ol': {
      margin: '0 0 8px 18px',
      lineHeight: 1.5
    },
    '& a': {
      textDecoration: 'underline'
    }
  },
  navBar: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#202332',
    height: 52,
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '8px 11px',
    position: 'relative',
    width: '100%',
    maxWidth: 'inherit',
    boxSizing: 'border-box',
    zIndex: 1
  }
}
